import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  permissions: [],
  timesheets: [],
  accounts: [],
  root: {},
  account: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      if (!action.payload) return;
      state.user = action.payload.user || state.user;
      state.permissions = action.payload.permissions || state.permissions;
      state.timesheets = action.payload.timesheets || state.timesheets;
      state.accounts = action.payload.accounts || state.accounts;
      state.root = action.payload.root || state.root;
      state.account = action.payload.account || state.account;
    },
    setAccounts: (state, action) => {
      state.accounts = action.payload || [];
    },
    clearUser: (state) => {
      state = initialState;
    },
  },
});

export const { setUser, setAccounts, clearUser } = userSlice.actions;

export default userSlice.reducer;
